/* HEARTNOKS theme — lightweight client JS */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.menu-toggle');
    if (!t) return;
    var nav = document.querySelector('.site-nav');
    if (!nav) return;
    var shown = nav.classList.toggle('is-open');
    nav.style.display = shown ? 'flex' : '';
    nav.style.position = shown ? 'absolute' : '';
    nav.style.top = shown ? '100%' : '';
    nav.style.left = shown ? '0' : '';
    nav.style.right = shown ? '0' : '';
    nav.style.flexDirection = shown ? 'column' : '';
    nav.style.background = shown ? '#FAF6F0' : '';
    nav.style.padding = shown ? '20px' : '';
    nav.style.borderBottom = shown ? '1px solid #E6DFD3' : '';
  });

  // Product variant swatches
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.product__swatch');
    if (!s) return;
    var wrap = s.closest('.product__variants');
    if (wrap) {
      wrap.querySelectorAll('.product__swatch').forEach(function (x) { x.classList.remove('is-selected'); });
      s.classList.add('is-selected');
      var idInput = document.querySelector('#ProductVariantId');
      if (idInput && s.dataset.variantId) idInput.value = s.dataset.variantId;
      var priceEl = document.querySelector('.product__price .now');
      if (priceEl && s.dataset.price) priceEl.textContent = s.dataset.price;
    }
  });

  // Product quantity buttons
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.product__qty button');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v += parseInt(b.dataset.step, 10) || 0;
    if (v < 1) v = 1;
    input.value = v;
  });

  // Product thumbnails -> main image
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.product__thumbs img');
    if (!t) return;
    var main = document.querySelector('.product__media-main img');
    if (main) main.src = t.dataset.full || t.src;
  });

  // Contact page correction for Shopify's cached page render.
  function fixContactPage() {
    if (window.location.pathname !== '/pages/contact') return;

    var main = document.getElementById('MainContent');
    if (!main) return;

    if (!document.querySelector('link[href*="page-contact-banner.css"]')) {
      var currentScript = document.currentScript || document.querySelector('script[src*="theme.js"]');
      var bannerCss = document.createElement('link');
      bannerCss.rel = 'stylesheet';
      bannerCss.href = currentScript && currentScript.src
        ? currentScript.src.replace(/theme\.js.*$/, 'page-contact-banner.css')
        : '/cdn/shop/t/24/assets/page-contact-banner.css';
      document.head.appendChild(bannerCss);
    }

    main.querySelectorAll('.crp-banner').forEach(function (banner) {
      banner.remove();
    });

    var style = document.createElement('style');
    style.textContent = [
      '#MainContent .hn-contact{padding-top:0!important;}',
      '#MainContent .hn-contact__inner{max-width:860px!important;}',
      '#MainContent .hn-contact__hero{display:block!important;min-height:0!important;padding:56px 24px 18px!important;border-bottom:0!important;text-align:center!important;}',
      '#MainContent .hn-contact__hero-copy{max-width:none!important;}',
      '#MainContent .hn-contact__hero h1{font-family:Fraunces,Georgia,serif!important;font-size:clamp(44px,5.2vw,68px)!important;line-height:1.04!important;}',
      '#MainContent .hn-contact__lede,#MainContent .hn-contact__promise,#MainContent .hn-contact__still,#MainContent .hn-contact__eyebrow,#MainContent .hn-contact__trust{display:none!important;}',
      '#MainContent .hn-contact__review{margin-top:0!important;padding-top:0!important;border-top:0!important;}',
      '#MainContent .hn-contact__section-head{margin-bottom:18px!important;text-align:center!important;}',
      '#MainContent .hn-contact__section-head h2{font-family:Fraunces,Georgia,serif!important;font-size:clamp(34px,4.2vw,52px)!important;}',
      '#MainContent .hn-contact__form-section{padding-top:20px!important;margin-top:22px!important;border-top:1px solid var(--color-border)!important;}',
      '#MainContent .hn-contact__fields{gap:24px!important;}',
      '#MainContent .hn-ph{padding-top:56px!important;padding-bottom:18px!important;}',
      '#MainContent .hn-ph__title{margin-bottom:0!important;}',
      '#MainContent .hn-ph__body,#MainContent .hn-ph__blocks,#MainContent .hn-ph__cta-wrap{display:none!important;}',
      '#MainContent .warranty-feedback{padding-bottom:56px!important;}',
      '#MainContent .warranty-feedback__inner{gap:20px!important;}',
      '#MainContent .warranty-feedback__panel{padding-top:22px!important;gap:20px!important;}',
      '#MainContent .warranty-feedback__panel:not(.warranty-feedback__panel--form){grid-template-columns:auto auto!important;justify-content:start!important;align-items:start!important;column-gap:22px!important;row-gap:10px!important;}',
      '#MainContent .warranty-feedback__panel:not(.warranty-feedback__panel--form) h2{margin-bottom:0!important;}',
      '#MainContent .warranty-feedback__rating{gap:12px!important;padding-top:2px!important;}',
      '#MainContent .warranty-feedback__stars{gap:5px!important;}',
      '@media(max-width:720px){#MainContent .hn-contact__hero{padding:40px 20px 16px!important;}#MainContent .hn-ph{padding:38px 20px 14px!important;}#MainContent .hn-ph__title{margin-bottom:0!important;}#MainContent .warranty-feedback{padding-bottom:42px!important;}#MainContent .warranty-feedback__panel{padding-top:20px!important;}}'
    ].join('');
    document.head.appendChild(style);

    var reviewTitle = main.querySelector('.hn-contact__section-head h2');
    if (reviewTitle) reviewTitle.textContent = "How's it going so far?";
    var stars = main.querySelector('.hn-contact__stars');
    if (stars) stars.setAttribute('aria-label', "How's it going so far?");

    function applyFeedbackText() {
      var feedbackTitle = main.querySelector('.warranty-feedback__panel:not(.warranty-feedback__panel--form) h2');
      if (!feedbackTitle) return;
      feedbackTitle.textContent = "How's it going so far?";
      var copy = feedbackTitle.closest('div');
      var existingText = copy ? copy.querySelector('.warranty-feedback__text') : null;
      if (copy && !existingText) {
        var text = document.createElement('p');
        text.className = 'warranty-feedback__text';
        text.textContent = 'Optional. This rating is used only by Heartnoks support and never changes what you see next.';
        feedbackTitle.insertAdjacentElement('afterend', text);
      }
    }
    applyFeedbackText();
    window.setTimeout(applyFeedbackText, 250);
    window.setTimeout(applyFeedbackText, 1000);
    window.addEventListener('load', applyFeedbackText, { once: true });

    main.querySelectorAll('.hn-ph__body, .hn-ph__blocks, .hn-ph__cta-wrap').forEach(function (node) {
      node.remove();
    });

    var fields = main.querySelector('.hn-contact__fields');
    if (fields && !fields.querySelector('input[name="contact[name]"]')) {
      var nameLabel = document.createElement('label');
      nameLabel.innerHTML = '<span>Name</span><input type="text" name="contact[name]" autocomplete="name" required>';
      fields.insertBefore(nameLabel, fields.firstElementChild);
    }

    function applyRatingState(rating) {
      var response = main.querySelector('[data-rating-response]');
      var message = main.querySelector('[data-rating-message]');
      if (!response || !message) return;
      response.hidden = false;
      message.textContent = 'Thanks. Your rating is included only with this registration so our support team can follow up if needed.';
    }

    main.addEventListener('click', function (event) {
      var star = event.target.closest('.hn-contact__star');
      if (!star) return;
      var rating = parseInt(star.getAttribute('data-star'), 10) || 0;
      window.setTimeout(function () { applyRatingState(rating); }, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixContactPage);
  } else {
    fixContactPage();
  }
})();

(function () {
  document.querySelectorAll('.hn-header__nav a, .hn-header__drawer a').forEach(function (link) {
    var label = link.textContent.trim().toLowerCase();
    if (label === 'recipe' || link.getAttribute('href') === '/collections/01') {
      link.href = '/pages/recipes';
    }
  });

  var path = window.location.pathname.toLowerCase();
  if (path === '/collections/01' || path === '/recipe') {
    window.location.replace('/pages/recipes');
    return;
  }

  if (window.location.pathname === '/pages/recipe-book') {
    window.location.replace('/pages/recipes');
  }
})();
